import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import HelpTooltip from "@/shared/components/help-tooltip";
import ToggleTab from "@/shared/components/toggle-tab";
import { NavigateOptions } from "react-router";
import { TrendingBrandsQuery } from "@/features/dashboard/features/trending-brand-section/types";
import AppSelect from "@/features/line-sheet-sets/app-select";

interface Props {
  query: TrendingBrandsQuery;
  setQuery: (
    updater: (prev: TrendingBrandsQuery) => TrendingBrandsQuery,
    navigateOpts?: NavigateOptions | undefined
  ) => void;
  clear: () => void;
}

export default function TrendingBrandsHeader({
  query,
  setQuery,
  clear,
}: Props) {
  const { t, tSentence } = useI18nHelper();
  const handleToggle = (index: number) => {
    setQuery((prev) => ({
      ...prev,
      by: index === 0 ? "order" : "view",
    }));
  };

  const trendingBrandsPeriodOptionList = [
    {
      name: t("common\:period.7days"),
      value: "7 days",
    },
    {
      name: t("common\:period.1month"),
      value: "1 month",
    },
    {
      name: t("common\:period.3month"),
      value: "3 months",
    },
    {
      name: t("common\:period.6month"),
      value: "6 months",
    },
    {
      name: t("common\:period.1year"),
      value: "1 year",
    },
  ];

  return (
    <Flex justifyContent={"space-between"} width={"100%"} mr={"4px"}>
      <Flex gap={"2px"} alignItems={"center"}>
        <Text textStyle={"body-lg-bold"}>{t("trending_brands_title")}</Text>
        <HelpTooltip
          text={tSentence("trending_brands_tooltip")}
          iconsSize={20}
        />
      </Flex>
      <Flex gap={"8px"}>
        <AppSelect
          name={"기간 선택"}
          isMultiple={false}
          isClearable={false}
          options={trendingBrandsPeriodOptionList}
          value={query.period ?? "7 days"}
          onSelect={(value) => {
            setQuery((prev) => ({
              ...prev,
              period: value!,
            }));
          }}
          width={"120px"}
        />
        <ToggleTab
          leftText={t("trending_brands_order_by_order_count")}
          rightText={t("trending_brands_order_by_view_count")}
          onChange={handleToggle}
          index={query.by ? (query.by === "order" ? 0 : 1) : 1}
        />
      </Flex>
    </Flex>
  );
}
